export function hasUnreadActivity(board: {
  dateLastActivity: Date;
  dateLastView: Date;
}): boolean;
export function hasUnreadActivity(board: {
  dateLastActivity?: Date;
  dateLastView?: Date;
}): boolean | undefined;
export function hasUnreadActivity(board: {
  dateLastActivity?: Date;
  dateLastView?: Date;
}): boolean | undefined {
  const { dateLastActivity, dateLastView } = board;
  if (dateLastActivity && dateLastView) {
    return dateLastActivity > dateLastView;
  } else {
    return undefined;
  }
}
